import { z } from 'zod';

export const FileSchema = z.object({
  id: z.string().uuid(),
  originalName: z.string(),
  filename: z.string(),
  mimetype: z.string(),
  size: z.number(),
  path: z.string(),
  url: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: z.string().optional(),
  entityType: z.string().optional(),
  entityId: z.string().optional(),
});

export type File = z.infer<typeof FileSchema>;
